import React, { useEffect, useState } from "react";
import { findInitialSchoolYear } from "../../../util/schoolYear";
import DropdownSchoolYear from "../../../unicomponents/Dropdowns/DropdownSchoolYear";
import DropdownHierarchyOne from "../../../unicomponents/Dropdowns/DropdownHierarchyOne";
import DropdownHierarchyTwo from "../../../unicomponents/Dropdowns/DropdownHierarchyTwo";
import DropdownHierarchyThree from "../../../unicomponents/Dropdowns/DropdownHierarchyThree";
import RegistrationVariousRecordInputTable from "../../../unicomponents/registrationVariousRecordInputTable/RegistrationVariousRecordInputTable";
import useVariousStudentRecords from "../../../hooks/useVariousStudentRecords";
import { useUIContext } from "../../../context/UIContext";
import { useAuthContext } from "../../../context/AuthContext";
import { checkHrteachers } from "../../../util/checkPermissions";
import SimpleAlertMessageBlock from "../../../unicomponents/SimpleAlertMessageBlock";
import { uploadImage } from "../../../api/uploader";
import imageCompression from "browser-image-compression";
import { useTranslation } from "react-i18next";

export default function DreamAndMuseum({
  settingData,
  inputData,
  schoolId,
  inputQueryConditions,
  hrTeachersData,
  variousRecordInfo,
}) {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    schoolYear: null,
    schoolYearId: "",
    hierarchyOneId: "",
    hierarchyTwoId: "",
    hierarchyThreeId: "",
    organPathForSort: "N/A",
    group: "",
  });

  const [queryConditions, setQueryConditions] = useState({
    schoolid: schoolId,
    school_year_id: "",
    record_list_id: inputQueryConditions?.record_list_id,
  });
  const [dataToSave, setDataToSave] = useState([]);
  const [savedRows, setSavedRows] = useState([]);
  // const [savedBulk, setSavedBulk] = useState(false);
  // const [confirmDelete, setConfirmDelete] = useState(false);

  // const memoizedConditions = useMemo(
  //   () => ({
  //     schoolid: queryConditions.schoolid,
  //     school_year_id: queryConditions.school_year_id,
  //     record_list_id: queryConditions.record_list_id,
  //   }),
  //   [
  //     queryConditions.schoolid,
  //     queryConditions.school_year_id,
  //     queryConditions.record_list_id,
  //   ]
  // );

  const {
    variousStudentRecordsQuery: { data: variousStudentData },
    createOrUpdateVariousStudentRecords,
  } = useVariousStudentRecords(queryConditions);

  const { setIsLoadingModal, handleToastCenterTop } = useUIContext();

  const { hasPermission } = useAuthContext();

  useEffect(() => {
    let initialSchoolYear = null;
    let initialSchoolYearId = null;

    if (filters.schoolYear === null && settingData && settingData.length > 0) {
      const initialData = findInitialSchoolYear(settingData)?.row;
      if (!initialData) return;

      //이거 궁극적으로는 termData를 join해 와서 그것으로 정렬해야겠다.
      // console.log(
      //   "초기데이터",
      //   settingData.sort((a, b) => compareSchoolYearDesc(a.school_year, b.school_year))
      // );

      initialSchoolYear = initialData.school_year;
      initialSchoolYearId = initialData.id;
      setFilters((filters) => ({
        ...filters,
        schoolYear: initialSchoolYear,
        schoolYearId: initialSchoolYearId,
      }));

      setQueryConditions((prev) => ({
        ...prev,
        school_year_id: initialSchoolYearId,
        record_list_id: inputQueryConditions?.record_list_id,
      }));
    } else {
      setQueryConditions((prev) => ({
        ...prev,
        school_year_id: filters.schoolYearId,
        record_list_id: inputQueryConditions?.record_list_id,
      }));
    }
  }, [
    filters.schoolYear,
    filters.schoolYearId,
    inputQueryConditions?.record_list_id,
    settingData,
  ]);

  useEffect(() => {
    if (hrTeachersData && filters.schoolYear)
      if (checkHrteachers(hrTeachersData, "", filters.schoolYear)) {
        const thisYearData = hrTeachersData.filter(
          (r) => r.schoolYear === filters.schoolYear
        );
        const splited = thisYearData[0].organization_path.split("/");

        setFilters((filters) => ({
          ...filters,
          hierarchyOneId: splited[2],
          hierarchyTwoId: splited[3],
          hierarchyThreeId: splited[4],
          organPathForSort: thisYearData[0].organization_path,
        }));
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.schoolYear, hrTeachersData]);

  useEffect(() => {
    if (variousStudentData) {
      const studentDataFilteredByGroup = variousStudentData.filter(
        (r) => r.group === filters.group
      );
      setDataToSave(studentDataFilteredByGroup);
    }
  }, [filters.group, variousStudentData]);

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const selectedOptionText = e.target.selectedOptions[0].text;
    const dataName = e.target.selectedOptions[0].getAttribute("data-name");
    let organPath = "";
    if (!dataName) {
      organPath = "N/A";
    } else {
      organPath = dataName + "/" + value;
    }

    if (name === "0") {
      setFilters((filters) => ({
        ...filters,
        schoolYear: selectedOptionText,
        schoolYearId: value,
        hierarchyOneId: "",
        organPathForSort: "N/A",
      }));
      setQueryConditions((prev) => ({ ...prev, school_year_id: value }));
    }

    if (name === "1") {
      setFilters((filters) => ({
        ...filters,
        hierarchyOneId: value,
        hierarchyTwoId: "",
        hierarchyThreeId: "",
        organPathForSort: "N/A",
      }));
    }

    if (name === "2") {
      setFilters((filters) => ({
        ...filters,
        hierarchyTwoId: value,
        hierarchyThreeId: "",
        organPathForSort: organPath,
      }));
    }

    if (name === "3") {
      setFilters((filters) => ({
        ...filters,
        hierarchyThreeId: value,
        organPathForSort: organPath,
      }));
    }
  };

  const handleSaveState = async (e, username, inputs_id) => {
    // console.log("dataToSave", dataToSave);
    // console.log(username);
    let value = e.target.value;
    let name = e.target.name;

    // 이미지 처리 추가
    const isFileInput = e.target.files && e.target.files[0] instanceof File; // File인지 확인
    // console.log("isFileInput", isFileInput);

    if (isFileInput) {
      const file = e.target.files[0]; // 선택된 파일
      // console.log("Original File Object:", file);

      try {
        // console.log("Original File Size:", value.size / 1024 / 1024, "MB");

        const options = {
          maxSizeMB: 1,
          useWebWorker: true,
          fileType: "image/jpeg",
        };

        const compressedFile = await imageCompression(file, options);
        // console.log(
        //   "Compressed File Size:",
        //   compressedFile.size / 1024 / 1024,
        //   "MB"
        // );
        value = compressedFile; // 리사이즈된 파일 설정
      } catch (error) {
        console.error("Image compression failed:", error);
        return;
      }
    }

    setDataToSave((prevData) => {
      const existingItem = prevData.find((item) => item.username === username);

      if (existingItem) {
        let updatedValueObject = {
          ...existingItem.value_object,
          [name]: value,
        };

        return prevData.map((item) =>
          item.username === username
            ? {
                ...item,
                value_object: updatedValueObject,
                isModified: true,
              }
            : item
        );
      } else {
        let valueObject = { [name]: value };
        return [
          ...prevData,
          {
            schoolid: schoolId,
            school_year_id: filters.schoolYearId, // 적절한 기본값을 설정합니다.
            record_list_id: inputQueryConditions?.record_list_id,
            group: "", // 적절한 기본값을 설정합니다.
            username,
            value_object: valueObject,
            isModified: true,
            // 기본값을 설정합니다. 필요에 따라 다른 기본값을 설정할 수 있습니다.
          },
        ];
      }
    });
  };

  const handleSaveClick = async (row) => {
    // console.log("row", row);
    // console.log("dataToSave", dataToSave);

    const trimmedDataToSave = dataToSave.map((item) => {
      const trimmedValueObject = Object.fromEntries(
        Object.entries(item.value_object).map(([key, value]) => [
          key,
          typeof value === "string" ? value.trim() : value,
        ])
      );
      return { ...item, value_object: trimmedValueObject };
    });

    const toSave = trimmedDataToSave.filter((r) => r.username === row.username);
    // console.log("toSave", toSave);

    // console.log("toSave.isModified", toSave.isModified);

    if (toSave.length < 1) {
      handleToastCenterTop(t("common.messages.notModifed"));

      return;
    }

    if (!toSave[0].isModified) {
      // 변경사항이 없는 경우, 제출을 건너뜁니다.
      console.log("건너뛰기");
      handleToastCenterTop(t("common.messages.notModifed"));
      return;
    }

    if (!hasPermission(null, "can_create")) {
      handleToastCenterTop(t("common.messages.noSavePermission"));
      return;
    }

    setIsLoadingModal(true);

    try {
      // 이미지 업로드 처리
      const updatedValueObject = { ...toSave[0].value_object }; // 기존 value_object 복사
      const imageFieldKeys = Object.keys(updatedValueObject).filter(
        (key) => updatedValueObject[key] instanceof File // File 객체만 필터링
      );

      // console.log("imageFieldKeys", imageFieldKeys);

      for (const imageFieldName of imageFieldKeys) {
        const file = updatedValueObject[imageFieldName];

        // console.log("file1", file);

        try {
          const imageUrl = await uploadImage(
            file,
            toSave[0].schoolid + "/dream-and-museum",
            row.username,
            row.fullname + "_"
          );
          updatedValueObject[imageFieldName] = imageUrl; // URL로 교체
        } catch (error) {
          console.error(`이미지 업로드 실패 (${imageFieldName}):`, error);
          alert("이미지 업로드 중 문제가 발생했습니다.");
          setIsLoadingModal(false);
          return;
        }
      }

      // console.log("updatedValueObject", updatedValueObject);

      // 데이터 업데이트
      const updatedToSave = {
        ...toSave[0],
        value_object: updatedValueObject, // 업데이트된 value_object 사용
      };

      createOrUpdateVariousStudentRecords.mutate(updatedToSave, {
        onSuccess: (successMessage) => {
          setIsLoadingModal(false);
          setSavedRows((prev) => [...prev, toSave[0].username]);
          setTimeout(() => {
            setSavedRows([]);
          }, 1000);

          // 성공적으로 제출 후, 해당 데이터 세트의 isModified 상태를 초기화합니다.
          setDataToSave((currentDataSets) =>
            currentDataSets.map((dataSet) =>
              dataSet.username === toSave[0].username
                ? { ...dataSet, isModified: false }
                : dataSet
            )
          );
        },
        onError: (error) => {
          setIsLoadingModal(false);
          console.error(error); // 일단 콘솔에 에러를 출력합니다.
          console.error("위와 같은 에러가 났으니 고치삼");
          alert(t("common.messages.errorAlert") + error.message);
        },
      });
    } catch (error) {
      console.error("전체 처리 실패:", error);
      alert("데이터 처리 중 문제가 발생했습니다.");
      setIsLoadingModal(false);
    }
  };

  return (
    <>
      <div className="row mt-3">
        <div className="col-1"></div>
        <div className="col">
          <DropdownSchoolYear
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYearId={filters.schoolYearId}
            allYears={false}
          />
        </div>
        <div className="col">
          <DropdownHierarchyOne
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYear={filters.schoolYear}
            hierarchyOneId={filters.hierarchyOneId}
          />
        </div>
        <div className="col">
          <DropdownHierarchyTwo
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYear={filters.schoolYear}
            hierarchyOneId={filters.hierarchyOneId}
            hierarchyTwoId={filters.hierarchyTwoId}
          />
        </div>
        <div className="col">
          <DropdownHierarchyThree
            settingData={settingData}
            handleDropdownChange={handleDropdownChange}
            schoolYear={filters.schoolYear}
            hierarchyTwoId={filters.hierarchyTwoId}
            hierarchyThreeId={filters.hierarchyThreeId}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="d-flex">
          <h3 className="fw-bold">
            {variousRecordInfo && variousRecordInfo.record_label}
          </h3>
          <div
            className="ms-2"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {variousRecordInfo?.description &&
              ` (${variousRecordInfo.description})`}
          </div>
        </div>
      </div>
      <div className="row mt-3">
        {!hasPermission(null, "can_read") ? (
          <SimpleAlertMessageBlock
            message={t("common.messages.noReadPermission")}
          />
        ) : (
          <div className="col" style={{ minWidth: "800px", overflowX: "auto" }}>
            <RegistrationVariousRecordInputTable
              organSettingInfo={filters}
              inputData={inputData}
              studentInputData={dataToSave}
              handleSaveState={handleSaveState}
              handleSaveClick={handleSaveClick}
              savedRows={savedRows}
              addfontSize=""
              addMinWidth="-5"
              hrTeachersData={hrTeachersData}
            />
          </div>
        )}
      </div>
    </>
  );
}
